export const Steps = Object.freeze({
    Question: 'question',
    Selection: 'selection',
    Answer: 'answer'
});
